'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const LoadUrlMatcherTypes=require('../../../../dist-es6/client/services/paramSyncService').LoadUrlMatcherTypes;let

ProfileConfig=class ProfileConfig{
static get $inject(){return['$stateProvider','$urlMatcherFactoryProvider']}

constructor($stateProvider,$urlMatcherFactoryProvider){
LoadUrlMatcherTypes($urlMatcherFactoryProvider);
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('profile');
$stateProvider.state(feature.fullName,feature.config);
}};


module.exports=ProfileConfig;
//# sourceMappingURL=profileConfig.js.map
